import React from "react";
import { Outlet } from "react-router-dom";

function ChampionsMain(props) {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}

export default ChampionsMain;
